// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A9hT","colMin":"styles_colMin__1fDKU"};